import { Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import React from 'react';
import { useTranslate } from 'src/locales';
import { CartItemDTO } from 'src/types';

import { CurrencyCodes } from '../../types/users/currency';
import { formatCurrency } from '../../utils/formatters/currency';
import TicketInfoHeader from './ticket-info-header';

type TicketSoldOutProps = {
  ticket: CartItemDTO;
  currency?: CurrencyCodes;
};

const TicketSoldOut = ({ ticket, currency }: TicketSoldOutProps) => {
  const { t } = useTranslate('common');

  return (
    <Stack direction="column" sx={{ backgroundColor: '#000', px: 2, py: 2, borderRadius: 2 }}>
      <TicketInfoHeader ticket={ticket} />
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="body2">{formatCurrency(ticket.net, currency)}</Typography>
        <Stack
          flexShrink={0}
          direction="row"
          alignItems="center"
          justifyContent="center"
          sx={{
            p: 0.5,
            borderRadius: 1,
            typography: 'subtitle2',
            backgroundColor: '#262323',
            border: (theme) => `solid 1px ${alpha(theme.palette.grey[500], 0.2)}`,
          }}
        >
          <Typography variant="subtitle1">{t('ticket.sold-out')}</Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default TicketSoldOut;
